import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    editorContent: null
});

class EmailEditorStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.UPDATE_EMAIL_EDITOR:
                return state
                    .set('editorContent', action.editorContent);

            default:
                return state;
        }
    }
}

export default new EmailEditorStore();



// WEBPACK FOOTER //
// src/stores/EmailEditorStore.js